// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-chat-content-wrapper {
  display: block;
  pointer-events: none;
  -webkit-user-select: text;
          user-select: text;
  padding-bottom: 16px;
}

.content-container {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.details-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-inline: 4px;
}
.details-section.edit-mode {
  gap: 0;
}
.details-section.edit-mode .time-container {
  margin-bottom: 12px;
}

.disabled-field {
  opacity: 0.4;
  pointer-events: none;
}

.subject-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.subject-row .subject {
  font-size: 20px;
  font-weight: 700;
  flex: 1;
  word-break: break-word;
}
.subject-row .action-buttons {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}
.subject-row .action-buttons .action-icon {
  font-size: 22px;
  cursor: pointer;
  color: var(--ion-text-color);
}

.time-container {
  display: flex;
  flex-direction: column;
  background: rgba(239, 239, 239, 0.5411764706);
  padding: 5px 10px;
  border-radius: 8px;
  gap: 2px;
}
.time-container .meeting-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time-container .meeting-time .start-end-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.time-container .meeting-time .start-end-container .all-day {
  margin: 4px;
  margin-left: 0;
}
.time-container .meeting-time .start-end-container .all-day ion-toggle {
  font-weight: 600;
  font-size: 13px;
  display: block;
  width: 100%;
  --track-background-checked: #ed143d;
}
.time-container .meeting-time .start-end-container div {
  display: flex;
  align-items: center;
}
.time-container .meeting-time .start-end-container div span {
  font-weight: 600;
  flex: 0.5;
  font-size: 13px;
  color: #888;
  margin: 0;
  padding: 0;
}
.time-container .meeting-time .start-end-container div ion-chip {
  display: flex;
  justify-content: center;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  white-space: nowrap;
}
.time-container .duration {
  display: flex;
  align-items: center;
  gap: 5px;
}
.time-container .duration span {
  display: flex;
  font-size: 13px;
  align-items: center;
  font-weight: 600;
  color: #888;
  gap: 5px;
}
.time-container .duration span ion-icon {
  color: #ed143d;
  font-size: 16px;
}
.time-container .duration ion-chip {
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1.2px;
}

.join-meeting-btn {
  --border-color: #5059c9;
  --color: #000;
  --border-radius: 10px;
  --border-width: 2px;
  --background: transparent;
  --background-activated: rgba(80, 89, 201, 0.08);
  --box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  height: 44px;
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  margin-top: 4px;
  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1));
}
.join-meeting-btn .teams-icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.propose-new-time-btn {
  --border-color: rgb(229, 231, 235);
  --color: #000;
  --color-activated: rgba(0, 0, 0, 0.6);
  --border-radius: 10px;
  --border-width: 1.5px;
  --background: transparent;
  --background-activated: rgba(229, 231, 235, 0.08);
  --background-hover: rgba(229, 231, 235, 0.6);
  height: 44px;
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  margin-top: 4px;
  display: flex;
  text-align: left;
}

.place-info.placeholder {
  display: flex;
  align-items: center;
  gap: 4px;
}
.place-info.placeholder .placeholder-location-icon {
  flex-shrink: 0;
  font-size: 14px;
  color: #ed143d;
}
.place-info.placeholder .placeholder-location-text {
  font-size: 13px;
  color: #999;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.place-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.place-info .resource-status-chip {
  margin-left: auto;
  flex-shrink: 0;
  min-height: unset;
  padding: 6px;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 10px;
  border-radius: 4px;
}
.place-info .resource-status-chip ion-icon {
  font-size: 11px;
  margin-right: 2px;
  -webkit-margin-end: 2px;
          margin-inline-end: 2px;
}
.place-info .resource-status-chip ion-label {
  font-size: 10px;
  font-weight: 600;
  margin: 0;
}
.place-info .place-avatar {
  flex-shrink: 0;
}
.place-info .place-avatar ion-avatar {
  width: 48px;
  height: 48px;
}
.place-info .place-avatar ion-avatar img {
  border-radius: 6px;
  background-size: cover;
}
.place-info .place-avatar ion-icon {
  font-size: 38px;
}
.place-info .place-details {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.place-info .place-details .place-name {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.place-info .place-details .place-email {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: var(--ion-color-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.place-info .place-details .place-email .email-icon {
  font-size: 11px;
  color: #ed143d;
  flex-shrink: 0;
}
.place-info .place-details .place-address {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: var(--ion-color-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.place-info .place-details .place-address .address-icon {
  font-size: 11px;
  color: #ed143d;
  flex-shrink: 0;
}
.place-info .place-details .place-address .no-address {
  font-style: italic;
  color: gray;
}

.detail-row {
  display: flex;
  align-items: center;
  font-size: 13px;
}
.detail-row .detail-label {
  color: #999;
  font-weight: 600;
  margin-right: auto;
}
.detail-row .detail-value {
  color: #999;
  font-weight: 500;
  text-align: right;
}

.organizer-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.status-icon {
  font-size: 18px;
  color: #ed143d;
  margin-right: 8px;
  flex-shrink: 0;
}

.series-info {
  display: flex;
  align-items: flex-start;
  gap: 5px;
}
.series-info .series-icon {
  font-size: 20px;
  color: #ed143d;
  flex-shrink: 0;
  margin-top: 1px;
}
.series-info .series-message {
  align-self: center;
  font-size: 10px;
  color: var(--ion-color-medium);
  line-height: 1.3;
}

.detail-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.detail-accordion ion-accordion {
  border-radius: 10px;
  border: 1.5px solid #e5e7eb;
  background: transparent;
}
.detail-accordion ion-accordion[disabled] {
  opacity: 0.45;
  pointer-events: none;
}
.detail-accordion ::ng-deep .ion-accordion-toggle-icon {
  font-size: 14px !important;
  color: #999 !important;
  margin-left: 8px;
  transform: rotate(0deg) !important;
  transition: transform 0.3s ease !important;
}
.detail-accordion ::ng-deep ion-accordion.accordion-expanding .ion-accordion-toggle-icon,
.detail-accordion ::ng-deep ion-accordion.accordion-expanded .ion-accordion-toggle-icon {
  transform: rotate(180deg) !important;
}
.detail-accordion .accordion-header {
  --padding-start: 8px;
  --inner-padding-end: 12px;
  border-radius: 10px 10px 0 0;
  --min-height: unset;
}
.detail-accordion .accordion-header .status-icon {
  margin-right: 8px;
}
.detail-accordion .accordion-header .detail-label {
  color: var(--ion-text-color, #000);
  font-weight: 600;
  font-size: 13px;
}
.detail-accordion .accordion-header .count-badge {
  font-size: 11px;
  min-width: 20px;
  background-color: #ed143d;
  --padding-start: 5px;
  --padding-end: 5px;
}
.detail-accordion .accordion-header .linked-badge {
  background-color: var(--ion-color-success);
  color: #fff;
}
.detail-accordion .accordion-header .unlinked-badge {
  background-color: var(--ion-color-medium);
  color: #fff;
}
.detail-accordion .participants-content {
  padding: 8px 8px 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.detail-accordion .images-content {
  padding: 8px;
}
.detail-accordion .images-content .images-swiper {
  border-radius: 8px;
  --swiper-pagination-color: #ed143d;
  --swiper-pagination-bullet-inactive-color: #ccc;
  --swiper-pagination-bullet-size: 6px;
}
.detail-accordion .images-content .resource-image-slide {
  display: flex;
  justify-content: center;
}
.detail-accordion .images-content .resource-image {
  width: 95%;
  border-radius: 8px;
  object-fit: cover;
  max-height: 200px;
}
.detail-accordion .map-content {
  padding: 8px;
}
.detail-accordion .map-content .map-container {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.detail-accordion .map-content .map-container iframe {
  border-radius: 8px;
  width: 100%;
  height: 100%;
}
.detail-accordion .floorplan-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.detail-accordion .floorplan-content .floorplan-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.detail-accordion .floorplan-content .floorplan-info .floorplan-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--ion-text-color);
}
.detail-accordion .floorplan-content .floorplan-info .floorplan-address {
  font-size: 11px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}
.detail-accordion .floorplan-content .floorplan-info .floorplan-address .address-icon {
  color: #ed143d;
  font-size: 13px;
  flex-shrink: 0;
}
.detail-accordion .floorplan-content .floorplan-preview {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f7;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail-accordion .floorplan-content .floorplan-preview canvas {
  border-radius: 8px;
  max-width: 100%;
}
.detail-accordion .floorplan-content .open-map-btn {
  --color: #ed143d;
  --border-color: #ed143d;
  font-size: 12px;
  margin-top: 2px;
}
.detail-accordion .description-accordion-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.detail-accordion .description-accordion-content .loading-container {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}
.detail-accordion .description-accordion-content .section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 8px;
}
.detail-accordion .description-accordion-content .section-label ion-icon {
  font-size: 18px;
}
.detail-accordion .description-accordion-content .desc-card {
  background: #f5f5f7;
  border-radius: 10px;
  padding: 12px 14px;
  color: var(--ion-text-color);
  max-height: 200px;
  overflow: auto;
}
.detail-accordion .description-accordion-content .desc-card .description-text {
  word-break: break-word;
}
.detail-accordion .description-accordion-content .desc-card .description-text ::ng-deep * {
  font-size: 11px !important;
}
.detail-accordion .description-accordion-content .desc-card .description-text ::ng-deep img {
  max-width: 100%;
  height: auto !important;
  border-radius: 4px;
}
.detail-accordion .description-accordion-content .attachments-section {
  display: flex;
  flex-direction: column;
}
.detail-accordion .description-accordion-content .attachment-card {
  display: flex;
  align-items: center;
  background: #f5f5f7;
  border-radius: 10px;
  padding: 8px 8px 8px 14px;
  margin-bottom: 6px;
}
.detail-accordion .description-accordion-content .attachment-card:last-child {
  margin-bottom: 0;
}
.detail-accordion .description-accordion-content .attachment-card .attachment-name {
  font-size: 13px;
  font-weight: 500;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 12px;
}
.detail-accordion .description-accordion-content .attachment-card .attachment-size {
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
  margin-right: 4px;
}
.detail-accordion .description-accordion-content .attachment-card .download-btn {
  --color: #ed143d;
  --padding-start: 4px;
  --padding-end: 4px;
  margin: 0;
  flex-shrink: 0;
  font-size: 14px;
}

.attendee-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.attendee-group .group-label {
  font-size: 9px;
  font-weight: 600;
  color: var(--ion-color-medium);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.attendee-group .attendee-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}

.attendee-item {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  overflow: hidden;
}
.attendee-item .response-icon {
  font-size: 12px;
  flex-shrink: 0;
}
.attendee-item .attendee-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}
.attendee-item .attendee-name {
  font-size: 11px;
  font-weight: 500;
  color: var(--ion-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.attendee-item .attendee-email {
  font-size: 9px;
  color: var(--ion-color-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invite-btn {
  --color: #ed143d;
  --padding-start: 4px;
  --padding-end: 4px;
  margin: 0 10px 0 0;
  height: 24px;
}
.invite-btn ion-icon {
  font-size: 16px;
}

.checkout-delegate-row {
  --inner-padding-end: 12px;
  --padding-start: 12px;
  border-radius: 8px;
  margin: 8px 0;
}
.checkout-delegate-row ion-icon {
  color: #ed143d;
  font-size: 20px;
}

.error-container {
  background: #ed143d;
  color: white;
  padding: 8px;
  font-size: 13px;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: start;
  justify-content: center;
  gap: 5px;
}
.error-container p {
  margin: 0;
}
.error-container ion-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.edit-subject-input {
  font-weight: 600;
  font-size: 15px;
}

.edit-select ion-icon {
  color: #ed143d;
  font-size: 18px;
  margin-right: 10px;
}

::ng-deep .edit-select::part(label) {
  color: #888;
  font-size: 13px;
}
::ng-deep .edit-select::part(container) {
  font-size: 13px;
}
::ng-deep .edit-select::part(icon) {
  color: #ed143d;
  transform: translateY(10px);
}

.online-meeting-toggle {
  font-weight: 600;
  font-size: 13px;
  display: block;
  margin-top: 8px;
  --track-background-checked: #ed143d;
  width: 100%;
}

ion-popover.datetime-popover::part(content) {
  --width: 350px;
  --max-width: 90%;
  --height: auto;
}

ion-popover.duration-popover {
  --offset-y: -200px;
}

ion-datetime {
  --ion-color-primary: #ed143d;
  box-shadow: none;
  padding-top: 8px;
}

ion-datetime::part(calendar-day):focus {
  box-shadow: none;
}

ion-datetime::part(time-button) {
  background: #fff9f9;
  border: 2px solid #ed143d;
  font-weight: 600;
}

ion-datetime.disabled-time::part(time-button) {
  pointer-events: none;
  opacity: 0.3;
}

ion-popover.forward-options {
  --min-width: unset !important;
}
ion-popover.forward-options ion-item {
  font-size: 14px;
}
ion-popover.forward-options ion-item ion-icon {
  margin-right: 10px;
}

.invitation-response-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 80px;
  border-radius: 12px;
  background: white;
  width: 85%;
  margin-inline: auto;
  padding: 0 16px;
  box-sizing: border-box;
  border: 1px solid #ed143d;
  background: var(--ion-background-color, #fff);
  z-index: 10000;
}
.invitation-response-container .response-loading {
  display: flex;
  justify-content: center;
  padding: 10px;
}
.invitation-response-container .response-actions {
  display: flex;
}
.invitation-response-container .response-actions .response-button {
  flex: 1;
  --border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  min-height: unset;
  height: 30px;
  margin-block: 6px;
  text-transform: none;
  letter-spacing: 0;
  --background: transparent;
  --background-activated: #ed143d;
  --background-hover: #ed143d;
  --color-hover: #ffffff;
  --color: black;
  --border-width: 0;
}
.invitation-response-container .response-actions .response-button.selected {
  --background: #ed143d;
  --color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/view-edit-booking/view-edit-booking.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,MAAA;AACJ;AACI;EACE,mBAAA;AACN;;AAIA;EACE,YAAA;EACA,oBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,OAAA;EACA,sBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAFJ;AAII;EACE,eAAA;EACA,eAAA;EACA,4BAAA;AAFN;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAJF;AAME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAJJ;AAMI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AAJN;AAMM;EACE,WAAA;EACA,cAAA;AAJR;AAMQ;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,mCAAA;AAJV;AAQM;EACE,aAAA;EACA,mBAAA;AANR;AAQQ;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AANV;AASQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAPV;AAaE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAXJ;AAaI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;AAXN;AAaM;EACE,cAAA;EACA,eAAA;AAXR;AAeI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAbN;;AAkBA;EACE,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+CAAA;EACA,iDAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,mDAAA;AAfF;AAiBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAfJ;;AAmBA;EACE,kCAAA;EACA,aAAA;EACA,qCAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iDAAA;EACA,4CAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhBF;AAkBE;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAlBF;AAoBE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;UAAA,sBAAA;AAlBN;AAqBI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAnBN;AAuBE;EACE,cAAA;AArBJ;AAuBI;EACE,WAAA;EACA,YAAA;AArBN;AAuBM;EACE,kBAAA;EACA,sBAAA;AArBR;AAyBI;EACE,eAAA;AAvBN;AA2BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAzBJ;AA2BI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzBN;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1BN;AA4BM;EACE,eAAA;EACA,cAAA;EACA,cAAA;AA1BR;AA8BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5BN;AA8BM;EACE,eAAA;EACA,cAAA;EACA,cAAA;AA5BR;AA+BM;EACE,kBAAA;EACA,WAAA;AA7BR;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAhCF;AAkCE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAhCJ;AAmCE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AAjCJ;;AAqCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AAlCF;;AAqCA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAlCF;AAoCE;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAlCJ;AAqCE;EACE,kBAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApCF;AAqCE;EACE,mBAAA;EACA,2BAAA;EACA,uBAAA;AAnCJ;AAqCI;EACE,aAAA;EACA,oBAAA;AAnCN;AAuCE;EACE,0BAAA;EACA,sBAAA;EACA,gBAAA;EACA,kCAAA;EACA,0CAAA;AArCJ;AAwCE;;EAEE,oCAAA;AAtCJ;AAyCE;EAEE,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;AAxCJ;AAyCI;EACE,iBAAA;AAvCN;AA0CI;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;AAxCN;AA2CI;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;AAzCN;AA4CI;EACE,0CAAA;EACA,WAAA;AA1CN;AA6CI;EACE,yCAAA;EACA,WAAA;AA3CN;AA+CE;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA7CJ;AAgDE;EACE,YAAA;AA9CJ;AAgDI;EACE,kBAAA;EAEA,kCAAA;EACA,+CAAA;EACA,oCAAA;AA/CN;AAkDI;EACE,aAAA;EACA,uBAAA;AAhDN;AAmDI;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAjDN;AAqDE;EACE,YAAA;AAnDJ;AAqDI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AAnDN;AAqDM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAnDR;AAwDE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAtDJ;AAwDI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtDN;AAwDM;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AAtDR;AAyDM;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAvDR;AAyDQ;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAvDV;AA4DI;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA1DN;AA4DM;EACE,kBAAA;EACA,eAAA;AA1DR;AA8DI;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AA5DN;AAgEE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA9DJ;AAgEI;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AA9DN;AAiEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA/DN;AAiEM;EACE,eAAA;AA/DR;AAmEI;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,iBAAA;EACA,cAAA;AAjEN;AAmEM;EACE,sBAAA;AAjER;AAmEU;EACE,0BAAA;AAjEZ;AAoEU;EACE,eAAA;EACA,uBAAA;EACA,kBAAA;AAlEZ;AAwEI;EACE,aAAA;EACA,sBAAA;AAtEN;AAyEI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAvEN;AAyEM;EACE,gBAAA;AAvER;AA0EM;EACE,eAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAxER;AA2EM;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAzER;AA4EM;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AA1ER;;AAgFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7EF;AA+EE;EACE,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,qBAAA;AA7EJ;AAgFE;EACE,aAAA;EACA,8BAAA;EACA,aAAA;AA9EJ;;AAkFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AA/EF;AAiFE;EACE,eAAA;EACA,cAAA;AA/EJ;AAkFE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAhFJ;AAmFE;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjFJ;AAoFE;EACE,cAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlFJ;;AAsFA;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAnFF;AAqFE;EACE,eAAA;AAnFJ;;AAuFA;EACE,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;AApFF;AAsFE;EACE,cAAA;EACA,eAAA;AApFJ;;AA0FA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;AAvFF;AAyFE;EACE,SAAA;AAvFJ;AA0FE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAxFJ;;AA4FA;EACE,gBAAA;EACA,eAAA;AAzFF;;AA6FE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AA1FJ;;AA+FE;EACE,WAAA;EACA,eAAA;AA5FJ;AA+FE;EACE,eAAA;AA7FJ;AAgGE;EACE,cAAA;EACA,2BAAA;AA9FJ;;AAkGA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;EACA,WAAA;AA/FF;;AAkGA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AA/FF;;AAkGA;EACE,kBAAA;AA/FF;;AAkGA;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AA/FF;;AAkGA;EACE,gBAAA;AA/FF;;AAkGA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;AA/FF;;AAkGA;EACE,oBAAA;EACA,YAAA;AA/FF;;AAkGA;EACE,6BAAA;AA/FF;AAgGE;EACE,eAAA;AA9FJ;AA+FI;EACE,kBAAA;AA7FN;;AAkGA;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,6CAAA;EACA,cAAA;AA/FF;AAiGE;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AA/FJ;AAkGE;EACE,aAAA;AAhGJ;AAkGI;EACE,OAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;AAhGN;AAiGM;EACE,qBAAA;EACA,gBAAA;AA/FR","sourcesContent":[".ai-chat-content-wrapper {\n  display: block;\n  pointer-events: none;\n  user-select: text;\n  padding-bottom: 16px;\n}\n\n.content-container {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.details-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-inline: 4px;\n\n  &.edit-mode {\n    gap: 0;\n\n    .time-container {\n      margin-bottom: 12px;\n    }\n  }\n}\n\n.disabled-field {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.subject-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n\n  .subject {\n    font-size: 20px;\n    font-weight: 700;\n    flex: 1;\n    word-break: break-word;\n  }\n\n  .action-buttons {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    flex-shrink: 0;\n\n    .action-icon {\n      font-size: 22px;\n      cursor: pointer;\n      color: var(--ion-text-color);\n    }\n  }\n}\n\n.time-container {\n  display: flex;\n  flex-direction: column;\n  background: #efefef8a;\n  padding: 5px 10px;\n  border-radius: 8px;\n  gap: 2px;\n\n  .meeting-time {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .start-end-container {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n\n      .all-day {\n        margin: 4px;\n        margin-left: 0;\n\n        ion-toggle {\n          font-weight: 600;\n          font-size: 13px;\n          display: block;\n          width: 100%;\n          --track-background-checked: #ed143d;\n        }\n      }\n\n      div {\n        display: flex;\n        align-items: center;\n\n        span {\n          font-weight: 600;\n          flex: 0.5;\n          font-size: 13px;\n          color: #888;\n          margin: 0;\n          padding: 0;\n        }\n\n        ion-chip {\n          display: flex;\n          justify-content: center;\n          border-radius: 12px;\n          font-weight: 700;\n          font-size: 13px;\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  .duration {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    span {\n      display: flex;\n      font-size: 13px;\n      align-items: center;\n      font-weight: 600;\n      color: #888;\n      gap: 5px;\n\n      ion-icon {\n        color: #ed143d;\n        font-size: 16px;\n      }\n    }\n\n    ion-chip {\n      border-radius: 12px;\n      font-weight: 700;\n      font-size: 13px;\n      letter-spacing: 1.2px;\n    }\n  }\n}\n\n.join-meeting-btn {\n  --border-color: #5059c9;\n  --color: #000;\n  --border-radius: 10px;\n  --border-width: 2px;\n  --background: transparent;\n  --background-activated: rgba(80, 89, 201, 0.08);\n  --box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1);\n  height: 44px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  margin-top: 4px;\n  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1));\n\n  .teams-icon {\n    width: 20px;\n    height: 20px;\n    margin-right: 6px;\n  }\n}\n\n.propose-new-time-btn {\n  --border-color: rgb(229, 231, 235);\n  --color: #000;\n  --color-activated: rgba(0, 0, 0, 0.6);\n  --border-radius: 10px;\n  --border-width: 1.5px;\n  --background: transparent;\n  --background-activated: rgba(229, 231, 235, 0.08);\n  --background-hover: rgba(229, 231, 235, 0.6);\n  height: 44px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  margin-top: 4px;\n  display: flex;\n  text-align: left;\n}\n\n.place-info.placeholder {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  .placeholder-location-icon {\n    flex-shrink: 0;\n    font-size: 14px;\n    color: #ed143d;\n  }\n\n  .placeholder-location-text {\n    font-size: 13px;\n    color: #999;\n    font-style: italic;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.place-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .resource-status-chip {\n    margin-left: auto;\n    flex-shrink: 0;\n    min-height: unset;\n    padding: 6px;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 10px;\n    border-radius: 4px;\n\n    ion-icon {\n      font-size: 11px;\n      margin-right: 2px;\n      margin-inline-end: 2px;\n    }\n\n    ion-label {\n      font-size: 10px;\n      font-weight: 600;\n      margin: 0;\n    }\n  }\n\n  .place-avatar {\n    flex-shrink: 0;\n\n    ion-avatar {\n      width: 48px;\n      height: 48px;\n\n      img {\n        border-radius: 6px;\n        background-size: cover;\n      }\n    }\n\n    ion-icon {\n      font-size: 38px;\n    }\n  }\n\n  .place-details {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n\n    .place-name {\n      font-size: 13px;\n      font-weight: 600;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .place-email {\n      display: flex;\n      align-items: center;\n      gap: 2px;\n      font-size: 11px;\n      color: var(--ion-color-medium);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      .email-icon {\n        font-size: 11px;\n        color: #ed143d;\n        flex-shrink: 0;\n      }\n    }\n\n    .place-address {\n      display: flex;\n      align-items: center;\n      gap: 2px;\n      font-size: 11px;\n      color: var(--ion-color-medium);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      .address-icon {\n        font-size: 11px;\n        color: #ed143d;\n        flex-shrink: 0;\n      }\n\n      .no-address {\n        font-style: italic;\n        color: gray;\n      }\n    }\n  }\n}\n\n.detail-row {\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n\n  .detail-label {\n    color: #999;\n    font-weight: 600;\n    margin-right: auto;\n  }\n\n  .detail-value {\n    color: #999;\n    font-weight: 500;\n    text-align: right;\n  }\n}\n\n.organizer-icon {\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n}\n\n.status-icon {\n  font-size: 18px;\n  color: #ed143d;\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n.series-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n\n  .series-icon {\n    font-size: 20px;\n    color: #ed143d;\n    flex-shrink: 0;\n    margin-top: 1px;\n  }\n\n  .series-message {\n    align-self: center;\n    font-size: 10px;\n    color: var(--ion-color-medium);\n    line-height: 1.3;\n  }\n}\n\n.detail-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  ion-accordion {\n    border-radius: 10px;\n    border: 1.5px solid #e5e7eb;\n    background: transparent;\n\n    &[disabled] {\n      opacity: 0.45;\n      pointer-events: none;\n    }\n  }\n\n  ::ng-deep .ion-accordion-toggle-icon {\n    font-size: 14px !important;\n    color: #999 !important;\n    margin-left: 8px;\n    transform: rotate(0deg) !important;\n    transition: transform 0.3s ease !important;\n  }\n\n  ::ng-deep ion-accordion.accordion-expanding .ion-accordion-toggle-icon,\n  ::ng-deep ion-accordion.accordion-expanded .ion-accordion-toggle-icon {\n    transform: rotate(180deg) !important;\n  }\n\n  .accordion-header {\n    // --background: transparent;\n    --padding-start: 8px;\n    --inner-padding-end: 12px;\n    border-radius: 10px 10px 0 0;\n    --min-height: unset;\n    .status-icon {\n      margin-right: 8px;\n    }\n\n    .detail-label {\n      color: var(--ion-text-color, #000);\n      font-weight: 600;\n      font-size: 13px;\n    }\n\n    .count-badge {\n      font-size: 11px;\n      min-width: 20px;\n      background-color: #ed143d;\n      --padding-start: 5px;\n      --padding-end: 5px;\n    }\n\n    .linked-badge {\n      background-color: var(--ion-color-success);\n      color: #fff;\n    }\n\n    .unlinked-badge {\n      background-color: var(--ion-color-medium);\n      color: #fff;\n    }\n  }\n\n  .participants-content {\n    padding: 8px 8px 8px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .images-content {\n    padding: 8px;\n\n    .images-swiper {\n      border-radius: 8px;\n\n      --swiper-pagination-color: #ed143d;\n      --swiper-pagination-bullet-inactive-color: #ccc;\n      --swiper-pagination-bullet-size: 6px;\n    }\n\n    .resource-image-slide {\n      display: flex;\n      justify-content: center;\n    }\n\n    .resource-image {\n      width: 95%;\n      border-radius: 8px;\n      object-fit: cover;\n      max-height: 200px;\n    }\n  }\n\n  .map-content {\n    padding: 8px;\n\n    .map-container {\n      width: 100%;\n      height: 200px;\n      border-radius: 8px;\n      overflow: hidden;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n      iframe {\n        border-radius: 8px;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n\n  .floorplan-content {\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    .floorplan-info {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n\n      .floorplan-label {\n        font-size: 13px;\n        font-weight: 600;\n        color: var(--ion-text-color);\n      }\n\n      .floorplan-address {\n        font-size: 11px;\n        color: #666;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n\n        .address-icon {\n          color: #ed143d;\n          font-size: 13px;\n          flex-shrink: 0;\n        }\n      }\n    }\n\n    .floorplan-preview {\n      width: 100%;\n      border-radius: 8px;\n      overflow: hidden;\n      background: #f5f5f7;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      canvas {\n        border-radius: 8px;\n        max-width: 100%;\n      }\n    }\n\n    .open-map-btn {\n      --color: #ed143d;\n      --border-color: #ed143d;\n      font-size: 12px;\n      margin-top: 2px;\n    }\n  }\n\n  .description-accordion-content {\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .loading-container {\n      display: flex;\n      justify-content: center;\n      padding: 12px 0;\n    }\n\n    .section-label {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 12px;\n      font-weight: 600;\n      color: #666;\n      margin-bottom: 8px;\n\n      ion-icon {\n        font-size: 18px;\n      }\n    }\n\n    .desc-card {\n      background: #f5f5f7;\n      border-radius: 10px;\n      padding: 12px 14px;\n      color: var(--ion-text-color);\n      max-height: 200px;\n      overflow: auto;\n\n      .description-text {\n        word-break: break-word;\n        ::ng-deep {\n          * {\n            font-size: 11px !important;\n          }\n\n          img {\n            max-width: 100%;\n            height: auto !important;\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n\n    .attachments-section {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .attachment-card {\n      display: flex;\n      align-items: center;\n      background: #f5f5f7;\n      border-radius: 10px;\n      padding: 8px 8px 8px 14px;\n      margin-bottom: 6px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      .attachment-name {\n        font-size: 13px;\n        font-weight: 500;\n        flex: 1;\n        min-width: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin-right: 12px;\n      }\n\n      .attachment-size {\n        font-size: 12px;\n        color: #999;\n        flex-shrink: 0;\n        margin-right: 4px;\n      }\n\n      .download-btn {\n        --color: #ed143d;\n        --padding-start: 4px;\n        --padding-end: 4px;\n        margin: 0;\n        flex-shrink: 0;\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n.attendee-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  .group-label {\n    font-size: 9px;\n    font-weight: 600;\n    color: var(--ion-color-medium);\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n  }\n\n  .attendee-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px 12px;\n  }\n}\n\n.attendee-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n  overflow: hidden;\n\n  .response-icon {\n    font-size: 12px;\n    flex-shrink: 0;\n  }\n\n  .attendee-info {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  .attendee-name {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--ion-text-color);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .attendee-email {\n    font-size: 9px;\n    color: var(--ion-color-medium);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.invite-btn {\n  --color: #ed143d;\n  --padding-start: 4px;\n  --padding-end: 4px;\n  margin: 0 10px 0 0;\n  height: 24px;\n\n  ion-icon {\n    font-size: 16px;\n  }\n}\n\n.checkout-delegate-row {\n  --inner-padding-end: 12px;\n  --padding-start: 12px;\n  border-radius: 8px;\n  margin: 8px 0;\n\n  ion-icon {\n    color: #ed143d;\n    font-size: 20px;\n  }\n}\n\n// ===== Edit mode styles =====\n\n.error-container {\n  background: #ed143d;\n  color: white;\n  padding: 8px;\n  font-size: 13px;\n  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  gap: 5px;\n\n  p {\n    margin: 0;\n  }\n\n  ion-icon {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n  }\n}\n\n.edit-subject-input {\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.edit-select {\n  ion-icon {\n    color: #ed143d;\n    font-size: 18px;\n    margin-right: 10px;\n  }\n}\n\n::ng-deep .edit-select {\n  &::part(label) {\n    color: #888;\n    font-size: 13px;\n  }\n\n  &::part(container) {\n    font-size: 13px;\n  }\n\n  &::part(icon) {\n    color: #ed143d;\n    transform: translateY(10px);\n  }\n}\n\n.online-meeting-toggle {\n  font-weight: 600;\n  font-size: 13px;\n  display: block;\n  margin-top: 8px;\n  --track-background-checked: #ed143d;\n  width: 100%;\n}\n\nion-popover.datetime-popover::part(content) {\n  --width: 350px;\n  --max-width: 90%;\n  --height: auto;\n}\n\nion-popover.duration-popover {\n  --offset-y: -200px;\n}\n\nion-datetime {\n  --ion-color-primary: #ed143d;\n  box-shadow: none;\n  padding-top: 8px;\n}\n\nion-datetime::part(calendar-day):focus {\n  box-shadow: none;\n}\n\nion-datetime::part(time-button) {\n  background: #fff9f9;\n  border: 2px solid #ed143d;\n  font-weight: 600;\n}\n\nion-datetime.disabled-time::part(time-button) {\n  pointer-events: none;\n  opacity: 0.3;\n}\n\nion-popover.forward-options {\n  --min-width: unset !important;\n  ion-item {\n    font-size: 14px;\n    ion-icon {\n      margin-right: 10px;\n    }\n  }\n}\n\n.invitation-response-container {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 80px;\n  border-radius: 12px;\n  background: white;\n  width: 85%;\n  margin-inline: auto;\n  padding: 0 16px;\n  box-sizing: border-box;\n  border: 1px solid #ed143d;\n  background: var(--ion-background-color, #fff);\n  z-index: 10000;\n\n  .response-loading {\n    display: flex;\n    justify-content: center;\n    padding: 10px;\n  }\n\n  .response-actions {\n    display: flex;\n\n    .response-button {\n      flex: 1;\n      --border-radius: 8px;\n      font-weight: 600;\n      font-size: 13px;\n      min-height: unset;\n      height: 30px;\n      margin-block: 6px;\n      text-transform: none;\n      letter-spacing: 0;\n      --background: transparent;\n      --background-activated: #ed143d;\n      --background-hover: #ed143d;\n      --color-hover: #ffffff;\n      --color: black;\n      --border-width: 0;\n      &.selected {\n        --background: #ed143d;\n        --color: #ffffff;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
